module.exports = __webpack_public_path__ + "media/application/images/ui/icon-minus-4369acec05e74a30a92ef78304b2ca71.png";